import React from 'react';
import {
  ExpandedPanel,
  PanelGrid,
  PanelField,
  PanelLabel,
  PanelValue,
  PanelLink,
  StatusBadge,
} from '../LiveMeetingsDashboard.styles';

function formatDateTime(iso) {
  if (!iso) return '—';
  return new Date(iso).toLocaleString(undefined, {
    month: 'short', day: 'numeric', year: 'numeric',
    hour: '2-digit', minute: '2-digit',
  });
}

export default function FailedPanel({ item }) {
  const { dlqData, meetingTitle, meetingUrl } = item;

  const errorMessage = dlqData?.errorMessage || dlqData?.error || '—';
  const failedStage  = dlqData?.failedStage || dlqData?.stage || '—';
  const retryCount   = dlqData?.retryCount ?? dlqData?.retries ?? '—';
  const category     = dlqData?._dlqCategory || 'unknown';
  const botId        = dlqData?.id || '—';

  const isRetriable = category === 'retriable';

  return (
    <ExpandedPanel>
      <PanelGrid $cols={3}>
        <PanelField>
          <PanelLabel>Bot ID</PanelLabel>
          <PanelValue style={{ fontFamily: 'monospace', fontSize: 12 }}>{botId}</PanelValue>
        </PanelField>

        <PanelField>
          <PanelLabel>Retry Eligibility</PanelLabel>
          <PanelValue>
            {isRetriable
              ? <StatusBadge $variant="active">Retriable</StatusBadge>
              : <StatusBadge $variant="high">Permanent</StatusBadge>
            }
          </PanelValue>
        </PanelField>

        <PanelField>
          <PanelLabel>Failed At Stage</PanelLabel>
          <PanelValue>{failedStage}</PanelValue>
        </PanelField>

        <PanelField>
          <PanelLabel>Retry Count</PanelLabel>
          <PanelValue>{retryCount}</PanelValue>
        </PanelField>

        <PanelField>
          <PanelLabel>Failed At</PanelLabel>
          <PanelValue>{formatDateTime(dlqData?.failedAt || dlqData?.updatedAt || item.createdAt)}</PanelValue>
        </PanelField>

        {meetingUrl && (
          <PanelField>
            <PanelLabel>Meeting URL</PanelLabel>
            <PanelLink href={meetingUrl} target="_blank" rel="noopener noreferrer">{meetingUrl}</PanelLink>
          </PanelField>
        )}
      </PanelGrid>

      {errorMessage !== '—' && (
        <PanelField style={{ marginTop: 4 }}>
          <PanelLabel>Error Message</PanelLabel>
          <PanelValue style={{ color: '#991b1b', fontFamily: 'monospace', fontSize: 12, whiteSpace: 'pre-wrap', wordBreak: 'break-word' }}>
            {errorMessage}
          </PanelValue>
        </PanelField>
      )}
    </ExpandedPanel>
  );
}
